<template>
    <v-menu
        offset-y
        content-class="dropdown-menu"
        transition="slide-y-transition"
        :ripple="false"
    >
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" height="24" :ripple="false">
                <span class="font-weight-bold"
                    >{{ value }} ({{ mapPublishersToCounts[value] }})</span
                >
                <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
        </template>
        <v-list class="list-section">
            <v-list-item
                v-for="(publisher, index) in publisherCounts"
                :key="index"
                @click="updateSelected(publisher.value)"
            >
                <v-list-item-title>{{ publisher.text }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'select-publisher',
    data() {
        return {
            value: 'All',
        };
    },
    computed: {
        mapPublishersToCounts() {
            // Count number of partners for each publisher
            const counts = {};
            this.$store.state.partners
                .map((partner) => partner.publisher)
                .forEach((publisherName) => {
                    counts[publisherName] = (counts[publisherName] || 0) + 1;
                });
            counts.All = this.$store.state.partners.length;
            return counts;
        },
        publisherCounts() {
            // Format counts for displaying in drop-down list
            return Object.entries(this.mapPublishersToCounts).map(
                ([name, count]) => ({
                    text: `${name} (${count})`,
                    value: name,
                })
            );
        },
    },
    methods: {
        updateSelected(value) {
            this.value = value;
            this.$emit('input', value);
        },
    },
};
</script>
<style lang="scss" scoped>
.v-menu__content {
    margin-top: 10px;
    border-radius: 6px;
}
.v-btn {
    margin-left: 5px;
    min-width: 138px !important;
    display: flex;
    justify-content: space-between;
}
</style>
